// @flow
import {connect} from 'react-redux';
import ESimReplacement from './ESimReplacement';
import {goToNextEsimPage} from '../../modules/SignUp';
import {isLoadingSelector} from '../../modules/LoadingStatus';
import type {DispatchProps, StateProps} from './ESimReplacement';
import type {StateType} from '../../modules/reducers';
import {hasVisibleSubscriptionsSelector} from '../../modules/Dashboard';
import {subscriptionsToActivateSelector} from '../../modules/Subscriptions';
import {
  eSimSelectedSuccess,
  fetchAvailableSim,
} from '../../modules/ESim';

const mapStateToProps = (state: StateType): StateProps => ({
  isLoading: isLoadingSelector(state, 'initSignUp'),
  hasVisibleSubscriptions: hasVisibleSubscriptionsSelector(state),
  hasSubscriptionToActivate: !!subscriptionsToActivateSelector(state).length,
});

const mapDispatchToProps: DispatchProps = {
  selectEsim: eSimSelectedSuccess,
  goToEsimCheck: goToNextEsimPage,
  fetchEsimReference: () => fetchAvailableSim('eSIM'),
};

export default connect(mapStateToProps, mapDispatchToProps)(ESimReplacement);
